export const COUNTRY_DASHBOARDS_VES = 'countryDashboardsVES';

export const COUNTRY_DASHBOARDS_VES_ACTIONS_NAME = {
  getIndicatorCards: `${COUNTRY_DASHBOARDS_VES}/getIndicatorCards`,
  getPersonInfo: `${COUNTRY_DASHBOARDS_VES}/getPersonInfo`,
  getTopRfSubjectsEvents: `${COUNTRY_DASHBOARDS_VES}/getTopRfSubjectsEvents`,
  getTopRfSubjectsGrowthRate: `${COUNTRY_DASHBOARDS_VES}/getTopRfSubjectsGrowthRate`,
  getEventsCountByTypes: `${COUNTRY_DASHBOARDS_VES}/getEventsCountByTypes`,
  getAgreementsCountByTypes: `${COUNTRY_DASHBOARDS_VES}/getAgreementsCountByTypes`,
};

export const COUNTRY_DASHBOARDS_VES_MUTATIONS_NAME = {
  setIndicatorCards: `${COUNTRY_DASHBOARDS_VES}/setIndicatorCards`,
  setPersonInfo: `${COUNTRY_DASHBOARDS_VES}/setPersonInfo`,
  setTopRfSubjectsEvents: `${COUNTRY_DASHBOARDS_VES}/setTopRfSubjectsEvents`,
  setTopRfSubjectsGrowthRate: `${COUNTRY_DASHBOARDS_VES}/setTopRfSubjectsGrowthRate`,
  setEventsCountByTypes: `${COUNTRY_DASHBOARDS_VES}/setEventsCountByTypes`,
  setAgreementsCountByTypes: `${COUNTRY_DASHBOARDS_VES}/setAgreementsCountByTypes`,
};

export const COUNTRY_DASHBOARDS_VES_GETTERS_NAME = {
  getIndicatorCards: `${COUNTRY_DASHBOARDS_VES}/getIndicatorCards`,
  getPersonInfo: `${COUNTRY_DASHBOARDS_VES}/getPersonInfo`,
  getTopRfSubjectsEvents: `${COUNTRY_DASHBOARDS_VES}/getTopRfSubjectsEvents`,
  getTopRfSubjectsGrowthRate: `${COUNTRY_DASHBOARDS_VES}/getTopRfSubjectsGrowthRate`,
  getEventsCountByTypes: `${COUNTRY_DASHBOARDS_VES}/getEventsCountByTypes`,
  getAgreementsCountByTypes: `${COUNTRY_DASHBOARDS_VES}/getAgreementsCountByTypes`,
};
